import { Component, Inject } from '@angular/core';
import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';
import { AutoLoginClient } from '../auto-login.client';
import { AuthClient } from '../auth.client';

@Component({
  selector: 'biz-expiration-session-modal',
  templateUrl: './expiration-session-modal.component.html',
  styleUrls: ['./expiration-session-modal.component.scss']
})
export class ExpirationSessionModalComponent {

  constructor(public modalComponentRef: BzgModalRef,
   @Inject(BZG_MODAL_DATA) public data: any) { }

  close() {
    location.reload();
    this.modalComponentRef.close();
  }

  confirm() {
    this.modalComponentRef.close('confirm');
  }
}
